import { Injectable } from "@angular/core";
import { ISectionPresenter } from '../../../models/section-presenter';
import { DeviceSettingsFeatureToggle } from "src/app/enums/feature-toggle.enum";
import { CommonService } from "src/app/services/common/common.service";
import { FeatureToggleService } from "src/app/services/feature-toggle/feature-toggle.service";
import { LocalStorageKey } from "src/app/enums/local-storage-key.enum";
import { PowerService } from "src/app/services/power/power.service";

@Injectable({
	providedIn: 'root'
})

export class SmartStandbySection implements ISectionPresenter {
	constructor(
		public commonService: CommonService,
		private featureToggle: FeatureToggleService,
		private power: PowerService,
	) {}

	public async isVisible():  Promise<boolean> {
		let isSmartStandbyAvailable = false;
		const isDTmachine = this.commonService.getLocalStorageValue(LocalStorageKey.DesktopMachine);
		const isFeatureToggleEnabled = this.isFeatureToggleEnabled();

		if (!isDTmachine && isFeatureToggleEnabled) {
			isSmartStandbyAvailable = await this.power.getSmartStandbyCapability();
		}

		return isSmartStandbyAvailable;
	}

	public isFeatureToggleEnabled(): boolean {
		return this.featureToggle.isDeviceSettingsFeatureAvailable(DeviceSettingsFeatureToggle.PowerSmartStandBy);
	}
}
